/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          wasteCategory: {
            type: 'string',
            enum: [
              'DISCARDED_TEXTILES',
              'GLASS',
              'METALS',
              'ORGANIC_WASTE',
              'PAINTS_&_SOLVENTS',
              'PAPER_&_CARDBOARD',
              'PCBS_&_PCTS',
              'PLASTICS',
              'RUBBER_WASTE',
              'UNKNOWN',
              'WASTE_OILS',
              'WOOD_WASTE',
            ],
          },
          disposalMethod: {
            type: 'string',
            enum: [
              'COMPOSTING_GARBAGE',
              'INCINERATE,_BURN_OR_DISPOSE_ON-SITE_(UNCERTIFIED)',
              'MUNICIPAL_GARBAGE_COLLECTION',
              'ON-SITE_DISPOSAL_(THIRD-PARTY_REVIEWED_OR_AUDITED)',
              'PRIVATE_THIRD-PART_RESPONSIBLE_DISPOSAL_(CERTIFIED)',
              'THIRD-PARTY_GARBAGE_COLLECTION_(UNCERTIFIED)',
              'UNKNOWN',
              "WASTE_IS_SEPARATED_AND_RECYCLED_OR_REUSED_FOR_ORGANIZATION'S_OWN_PRODUCTION_OR_DONATED/PROVIDED_TO_OTHER_FACILITIES",
            ],
          },
          unit: {
            type: 'string',
            enum: ['KILOGRAM', 'METRIC_TON'],
          },
          totalAnnualVolume: {
            type: 'number',
          },
          year: {
            type: 'number',
            minimum: 1000,
            maximum: 9000,
          },
        },
        required: ['wasteCategory', 'disposalMethod', 'unit', 'totalAnnualVolume', 'year'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    waste_sources: valueSchema,
  },
}
